export const QUOTES_SECTION_KEY = 'QUOTES';
export const QUOTES_ACTION_SECTION_KEY = 'QUOTE_ACTION';